import moment from 'moment';

export const getDiffTime = (startTime, endTime) => (
  moment.utc( moment(endTime||moment()).diff(moment(startTime)) ).format("HH:mm:ss")
)

export const convertPercentToDecimal = (value) => (
  (value) ? value / 100 : null
)

export const convertDecimalToPercent = (value) => (
  (value) ? value * 100 : null
)
